import type { WebTestIdPath, WebTestIdsMap } from '@frontend/test-utils';
import { getWebTestId } from '@frontend/test-utils';
import { useMemo } from 'react';

// Should return a record of test ids (strictly typed)
export const useTestIds = <K extends WebTestIdPath>(paths: K[]) => {
  const resolvedTestIds = useMemo(() => {
    return paths.reduce(
      (acc, path) => {
        // eslint-disable-next-line fp/no-mutation
        acc[path] = getWebTestId(path);
        return acc;
      },
      {} as { [P in K]: ValueForKey<WebTestIdsMap, P> },
    );
  }, [paths]);

  return resolvedTestIds;
};
